import "tailwindcss/dist/base.css"
import "swiper/css/swiper.css"
import "./src/styles/global.css"

import "typeface-poppins"

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  const currentPosition = getSavedScrollPosition(location)

  // Avoid scroll up when changing url in search
  if (!location.pathname.startsWith("/search/")) {
    window.scrollTo(...(currentPosition || [0, 0]))
  }

  return false
}
